<template>
  <form novalidate class="md-layout" @submit.prevent="validateUser">
    <div class="md-layout-item md-elevation-0">

      <md-card class="md-elevation-0 m-5">
        <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Origen de Fondos
        </md-card-header>
        <md-card-content class="md-layout">
          <p align="justify">
          Ante cualquier duda, comuníquese con su promotor.
          </p>
        </md-card-content> 
      </md-card>   

      <md-card class="md-elevation-0 m-5" :class="getValidationClass2('declaracion')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Declaración jurada de origen de fondos *
        </md-card-header>
        <md-card-content class="md-layout">

          <div class="md-layout-item md-layout">
            <div class="md-layout-item md-xlarge-size-15 md-large-size-15 md-medium-size-15 md-small-size-25 md-xsmall-size-30">
              <md-checkbox v-model="form.declaracion" value="Remuneraciones">Remuneraciones</md-checkbox>
              <md-checkbox v-model="form.declaracion" value="Ahorros">Ahorros</md-checkbox>
              <md-checkbox v-model="form.declaracion" value="Préstamos">Préstamos</md-checkbox>
              <md-checkbox v-model="form.declaracion" value="Acciones">Acciones</md-checkbox>
              <md-checkbox v-model="form.declaracion" value="Inmuebles" >Inmuebles</md-checkbox>
              <md-checkbox v-model="form.declaracion" value="Otros" @change="ChangeOption">Otros</md-checkbox>
            </div>
            <div class="md-layout md-layout-item md-gutter md-alignment-bottom-left">
                <div class="md-layout-item">

                  <md-field class="md-field-aux" :class="getValidationClass('declaraciondes')">
                    <md-input type="text" name="otros" placeholder="Su respuesta" v-model="form.declaraciondes" :disabled="otros" autocomplete="off" />
                    <span class="md-error" v-if="!$v.form.declaraciondes.required">Su respuesta es obligatoria.</span>
                    <span class="md-error" v-else-if="!$v.form.declaraciondes.alpha1">Formato inválido</span>
                    <span class="md-error" v-else-if="!$v.form.declaraciondes.minLength">Formato inválido</span>
                  </md-field>   

                </div>

            </div>
          </div>   
          
            <div class="radioform" :class="getValidationClass('declaracion')">
              <span class="md-error" v-if="!$v.form.declaracion.required">Esta respuesta es obligatoria.</span>
            </div>                     

        </md-card-content> 
      </md-card>    

      <md-card class="md-elevation-0 m-5" :class="getValidationClass('detalle')">
        <md-card-header class="md-layout md-alignment-center-left justify">
          Brindar detalle de la opción elegida en la pregunta anterior
        </md-card-header>
        <md-card-content>
          <p align="justify">
            En caso la información brindada en esta pregunta no sea completada o sea incongruente, se congelará el proceso de suscripción hasta comprobar el origen de los fondos.
          </p>
          
          <div>
            
            <md-field :class="getValidationClass('detalle')">
              <md-input type="text" name="detalle" placeholder="Su respuesta" v-model="form.detalle" autocomplete="off"/>
              <span class="md-error" v-if="!$v.form.detalle.required">Esta respuesta es obligatoria.</span>
              <span class="md-error" v-else-if="!$v.form.detalle.minLength">Formato inválido</span>
              <span class="md-error" v-else-if="!$v.form.detalle.alpha">Formato inválido</span>
            </md-field>            

          </div>
        </md-card-content> 
      </md-card>          

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>                 

    </div>
  </form>
</template>

<style>

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha1 } from '../variables'
import {
  required,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Form7',
  data: () => ({
    form:{
      declaracion: null,
      declaraciondes : null,
      detalle: null
    }
  }),
  mounted: function(){
    this.form = this.$store.state.form.form7
  },  
  validations: {
    form: {
      declaracion: {
        required,
      },
      declaraciondes: {
        required: requiredIf(function(form){
          return this.findArray(form.declaracion)
        }),
        alpha1,
        minLength: minLength(3),    
      },
      detalle: {
        required,
        minLength: minLength(3),
        alpha1
      }
    },
  },
  methods: {
    ChangeOption(item){
      var that = this;
      item.find(x => {
        if(x != "Otros"){
          that.form.declaraciondes = null
        }
      });
    },    
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.form.form7
    },    
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {

        this.$emit('setSaveForm', {id:"7", form: this.form, index: "8"});
        
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }

    },    
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },
    findArray(arr){

      try {
        return (arr.find(x => x == "Otros") == "Otros")
      } catch (error) {
        return true;
      }

    }      
  },
  computed: {
    // a computed getter
    otros: function () {
      return !this.findArray(this.form.declaracion)
    }
  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
